import {
  BarChartOutlined,
  SearchOutlined,
  SendOutlined,
  SettingOutlined,
  SolutionOutlined,
  UserDeleteOutlined,
} from '@ant-design/icons'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { useIsRootAdmin, useIsSystemAdmin } from '@/modules/admin/admin.hooks'
import { routes } from '@/routes'

import { AsideMenuItem } from './aside-menu-item.component'
import s from './aside.module.less'

export const AsideAdminComponent: React.FC = () => {
  const { t } = useTranslation()

  const isRootAdmin = useIsRootAdmin()
  const isSystemAdmin = useIsSystemAdmin()

  if (!isRootAdmin && !isSystemAdmin) {
    return null
  }

  const adminItems = (isRootAdmin || isSystemAdmin) && (
    <>
      <AsideMenuItem title={t('admin.allPosts')} path={routes.admin.allPosts()} icon={<SendOutlined />} />
      <AsideMenuItem title='未登录用户' path={routes.admin.onboardingUsers()} icon={<UserDeleteOutlined />} />
      <AsideMenuItem title={t('charts.title')} path={routes.statistics.home()} icon={<BarChartOutlined />} />
      <AsideMenuItem title='影响力查询' path={routes.admin.impactQuery()} icon={<SearchOutlined />} />
      <AsideMenuItem title='年度报告' path={routes.annualReport.home()} icon={<SolutionOutlined />} />
      <AsideMenuItem title='Root' path={routes.admin.system()} icon={<SettingOutlined />} />
    </>
  )

  return (
    <div className={s.menuItem}>
      <div className={s.title}>
        <span>系统管理</span>
      </div>
      {adminItems}
    </div>
  )
}
